import {Component, OnInit} from '@angular/core';
import {VERSION} from '@env/version';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  version: string;

  constructor() {}

  ngOnInit() {
    this.version = VERSION;
  }

}
